import { NodeType } from "../app.types";

export const getNodeName = (
  name: string,
  email: string,
  type: NodeType
): string => {
  return type === "USR" ? `${name || ""} (${email || ""})` : name || "";
};
